import { breakpoints } from './utils/breakpoints';

class Pricing {
    constructor() {
        this.class = {
            module: '.module-pricing',
            imageWrapper: '.image-wrapper',
            container: '.pricing-body',
        };

        this.pricetableScrollHandler = this.pricetableScrollHandler.bind(this);
        this.updateParallaxEffect = this.updateParallaxEffect.bind(this);

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.init();
            }, false);
        } else {
            this.init();
        }
    }

    init() {
        this.updateParallaxEffect();
        window.addEventListener('resize', this.checkViewportWidth.bind(this));
        this.checkViewportWidth();
    }

    checkViewportWidth() {
        if (window.innerWidth > breakpoints.lg) {
            this.pricetableScrollHandler();
            this.updateParallaxEffect();
        } else {
            window.removeEventListener('scroll', this.updateParallaxEffect);
        }
    }

    pricetableScrollHandler() {
        window.addEventListener('scroll', this.updateParallaxEffect);
    }

    updateParallaxEffect() {
        if (window.innerWidth >= breakpoints.md) {
            const module = document.querySelector(this.class.module);

            if (module) {
                const imageWrapper = module.querySelector(this.class.imageWrapper);
                const container = module.querySelector(this.class.container);
                const offset = 0.3 * window.innerHeight;

                if (imageWrapper && container) {
                    const containerRect = container.getBoundingClientRect();
                    const containerHeight = containerRect.height;
                    const containerTop = containerRect.top;
                    const windowHeight = window.innerHeight;

                    const scrollPosition = window.scrollY || window.pageYOffset;
                    const visibleTop = Math.max(0, scrollPosition + windowHeight - (containerTop + offset));
                    const visiblePercentage = Math.max(0, Math.min(1, visibleTop / (containerHeight + windowHeight)));

                    const startTranslateY = 30;
                    const endTranslateY = -10;
                    const translateY = startTranslateY + (endTranslateY - startTranslateY) * visiblePercentage;

                    imageWrapper.style.transform = `translateY(${translateY}%)`;
                }
            }
        }
    }
}

export default new Pricing();
